/**
 * Initialize Sentry for error tracking and performance monitoring.
 * 
 * Depending on the bundle, this function initializes Sentry for Browser or Vue integration.
 * It sets the DSN for the wdt-js project and the environment based on the current hostname.
 * 
 * @param Sentry the Sentry instance from @sentry/browser or @sentry/vue
 * @param vueInstance optional Vue instance if using Sentry with Vue
 */
export function initSentry(Sentry, vueInstance = false) {
    const host = window?.location.hostname;
    const envMap = {
        'localhost': 'dev',
        'testing.wedesigntrips.com': 'testing',
        'staging.wedesigntrips.com': 'staging',
        'wedesigntrips.com': 'production',
        'www.wedesigntrips.com': 'production'
    };

    const environment = envMap[host] || (
        host && host.indexOf('.localhost') === host.length - '.localhost'.length ? 'dev' : 'unknown'
    );

    const sentryConfig = {
        dsn: process.env.SENTRY_DSN_JS || "",
        integrations: [
            Sentry.browserTracingIntegration(),
        ],
        tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
        sendDefaultPii: false, // Defaulting to false as in WebsiteBundle, AcquisitionBundle had it true
        environment,
    };

    if (vueInstance) {
        sentryConfig.Vue = vueInstance;
    }

    Sentry.init(sentryConfig);
}
